import ImageAndTextRow from '@af/design-system-docs-ui/image-and-text-row';
import ImageAndTextRowContainer from '@af/design-system-docs-ui/image-and-text-row-container';
import accelerateAi from "../../../../src/pages/patterns/ai-interaction-guidelines/_assets/accelerate-ai.png";
import accelerateAiDark from "../../../../src/pages/patterns/ai-interaction-guidelines/_assets/accelerate-ai-dark.png";
import ambientAi from "../../../../src/pages/patterns/ai-interaction-guidelines/_assets/ambient-ai.png";
import ambientAiDark from "../../../../src/pages/patterns/ai-interaction-guidelines/_assets/ambient-ai-dark.png";
import atlassianAi from "../../../../src/pages/patterns/ai-interaction-guidelines/_assets/atlassian-ai.png";
import atlassianAiDark from "../../../../src/pages/patterns/ai-interaction-guidelines/_assets/atlassian-ai-dark.png";
import collectiveAi from "../../../../src/pages/patterns/ai-interaction-guidelines/_assets/collective-ai.png";
import collectiveAiDark from "../../../../src/pages/patterns/ai-interaction-guidelines/_assets/collective-ai-dark.png";
import maintainAi from "../../../../src/pages/patterns/ai-interaction-guidelines/_assets/maintain-ai.png";
import maintainAiDark from "../../../../src/pages/patterns/ai-interaction-guidelines/_assets/maintain-ai-dark.png";
import dynamicAi from "../../../../src/pages/patterns/ai-interaction-guidelines/_assets/dynamic-ai.png";
import dynamicAiDark from "../../../../src/pages/patterns/ai-interaction-guidelines/_assets/dynamic-ai-dark.png";
import popAi from "../../../../src/pages/patterns/ai-interaction-guidelines/_assets/pop-ai.png";
import popAiDark from "../../../../src/pages/patterns/ai-interaction-guidelines/_assets/pop-ai-dark.png";
import multiAi from "../../../../src/pages/patterns/ai-interaction-guidelines/_assets/multi-ai.png";
import multiAiDark from "../../../../src/pages/patterns/ai-interaction-guidelines/_assets/multi-ai-dark.png";
import * as React from 'react';
export default {
  ImageAndTextRow,
  ImageAndTextRowContainer,
  accelerateAi,
  accelerateAiDark,
  ambientAi,
  ambientAiDark,
  atlassianAi,
  atlassianAiDark,
  collectiveAi,
  collectiveAiDark,
  maintainAi,
  maintainAiDark,
  dynamicAi,
  dynamicAiDark,
  popAi,
  popAiDark,
  multiAi,
  multiAiDark,
  React
};